import { render, staticRenderFns } from "./DisplayByRates.vue?vue&type=template&id=8a126e56&scoped=true"
import script from "./DisplayByRates.vue?vue&type=script&lang=js"
export * from "./DisplayByRates.vue?vue&type=script&lang=js"
import style0 from "./DisplayByRates.vue?vue&type=style&index=0&id=8a126e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a126e56",
  null
  
)

export default component.exports